import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ColumnOption } from '../../../models/maintenance-costing.model';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { MaintenanceContractColumnService } from '../../../services/maintenance-contract-column.service';
import {
  MAINTENANCE_CONTRACT_COLUMNS,
  MAX_MAINTENANCE_CONTRACT_COLUMNS,
  MIN_MAINTENANCE_CONTRACT_COLUMNS
} from '../../../constants/maintenance-contract-columns.constants';

@Component({
  selector: 'app-customize-column-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslocoDirective, TranslocoPipe],
  templateUrl: './customize-column-modal.component.html',
  styleUrl: './customize-column-modal.component.scss'
})
export class CustomizeColumnModalComponent {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private columnService: MaintenanceContractColumnService = inject(MaintenanceContractColumnService);

  readonly minSelections = MIN_MAINTENANCE_CONTRACT_COLUMNS;
  readonly maxSelections = MAX_MAINTENANCE_CONTRACT_COLUMNS;

  columns: ColumnOption[] = [];

  constructor() {
    const selectedColumns = this.columnService.getSelectedColumns();

    this.columns = MAINTENANCE_CONTRACT_COLUMNS.map(column => ({
      labelKey: column.labelKey,
      value: column.value,
      selected: selectedColumns.includes(column.value)
    }));
  }

  get selectedCount(): number {
    return this.columns.filter(col => col.selected).length;
  }

  get canSelectMore(): boolean {
    return this.selectedCount < this.maxSelections;
  }

  toggleColumn(column: ColumnOption): void {
    if (column.selected) {
      column.selected = false;
    } else if (this.canSelectMore) {
      column.selected = true;
    }
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  get isSaveDisabled(): boolean {
    return this.selectedCount < this.minSelections;
  }

  save(): void {
    const selectedColumns = this.columns
      .filter(col => col.selected)
      .map(col => col.value);
    this.columnService.storeSelectedColumns(selectedColumns);
    this.activeModal.close(selectedColumns);
  }
}